import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/roundtables/${id}/generate-exportable-data`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/generateExportableData.js